export enum actionTypes{
    getNews
}